import Banner1 from "../../media/banner1/banner (1).webp";
import Banner2 from "../../media/banner1/banner (2).webp";
import Banner3 from "../../media/banner1/banner (3).webp";
import Banner4 from "../../media/banner1/banner (4).webp";

const images = [Banner1, Banner2, Banner3, Banner4];

export default images;
